import { readSort, type ModuleSorts, type SortDir } from '@/components/records/registerSort'
import { isWaitingOn } from '@/constants/queueStates'

// SA-1192: the list's parameters, the ones this page reads from the URL.
// Opening a record and the in-page Back rebuild the URL from these (plus a
// module view), never from "the current URL plus `order`", so a record's own
// parameter (`order`, `panel`, `step`) never reaches the list.
export const LIST_PARAMS = [
  'search', 'contact_id', 'commercial_status', 'quote_status', 'process_state', 'waiting_on', 'sort', 'dir',
] as const

/** The list state a Quotes URL means (SA-1338). Empty string / null = no filter. */
export interface UrlList {
  search: string
  contactId: string | null
  commercialStatus: string
  quoteStatus: string
  processState: string
  waitingOn: string
  sortBy: string
  sortDir: SortDir | null
}

/** The ONE reader of the list a URL means. `step` is deliberately not read:
 *  `?step=` is the step drawer's address on the record lane. The register
 *  understands exactly one process_state value, and seeds only a waiting_on
 *  role the server accepts. */
export function listFromUrl(params: URLSearchParams, moduleSorts: ModuleSorts): UrlList {
  const processState = params.get('process_state')
  const waitingOn = params.get('waiting_on')
  const { sortBy, sortDir } = readSort(params.get('sort'), params.get('dir'), moduleSorts)
  return {
    search: params.get('search') ?? '',
    contactId: params.get('contact_id') || null,
    commercialStatus: params.get('commercial_status') ?? '',
    quoteStatus: params.get('quote_status') ?? '',
    processState: processState === 'not_started' ? processState : '',
    waitingOn: isWaitingOn(waitingOn) ? waitingOn : '',
    sortBy,
    sortDir,
  }
}
